var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1286_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.883 12.1382C17.883 11.7304 17.8499 11.3203 17.7794 10.919H12.12V13.2295H15.3609C15.2264 13.9747 14.7943 14.6339 14.1615 15.0528V16.552H16.095C17.2304 15.5069 17.883 13.9637 17.883 12.1382Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 18.0004C13.7382 18.0004 15.1029 17.4691 16.0972 16.5519L14.1637 15.0528C13.6258 15.4187 12.9313 15.626 12.1222 15.626C10.5569 15.626 9.22967 14.57 8.75346 13.1501H6.75824V14.6956C7.7768 16.7217 9.85139 18.0004 12.12 18.0004Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75126 13.1501C8.49993 12.405 8.49993 11.5981 8.75126 10.8529V9.3074H6.75825C5.90724 11.0028 5.90724 13.0002 6.75825 14.6956L8.75126 13.1501Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 8.37483C12.9754 8.3616 13.8021 8.68348 14.4217 9.27433L16.1347 7.56131C15.05 6.54275 13.6103 5.98277 12.12 6.0004C9.85139 6.0004 7.7768 7.27911 6.75824 9.3074L8.75126 10.8529C9.22526 9.43087 10.5547 8.37483 12.12 8.37483Z",
    fill: "#EA4335"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1286_1137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8b9436d1ccc337a3305bd08ed3729ceb.svg";
export { ForwardRef as ReactComponent };